"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributesMeta = exports.getAttributeMeta = exports.AttributeIsPercent = exports.AttributeIsHarmful = exports.AttributeIsSkipped = void 0;
const Record_1 = require("../utils/Record");
const enums_1 = require("../core/enums");
exports.AttributeIsSkipped = {
    [enums_1.AttributeType.VulnerabilityStacks]: true,
    [enums_1.AttributeType.HasteStacks]: true,
    [enums_1.AttributeType.SlowStacks]: true,
};
exports.AttributeIsHarmful = {
    [enums_1.AttributeType.VulnerabilityStacks]: true,
    [enums_1.AttributeType.SlowStacks]: true,
    [enums_1.AttributeType.RevengeStacks]: true,
    [enums_1.AttributeType.PercentHealingDecrease]: true,
    [enums_1.AttributeType.PercentHealingReceivedDecrease]: true,
};
exports.AttributeIsPercent = {
    [enums_1.AttributeType.CriticalStrikeChance]: true,
    [enums_1.AttributeType.CriticalDamageMultiplier]: true,
    [enums_1.AttributeType.CriticalDamageReductionPercent]: true,
    [enums_1.AttributeType.Accuracy]: true,
    [enums_1.AttributeType.Dodge]: false,
    [enums_1.AttributeType.Haste]: true,
    [enums_1.AttributeType.PercentHealingIncrease]: true,
    [enums_1.AttributeType.PercentHealingDecrease]: true,
    [enums_1.AttributeType.BleedDamageIncrease]: true,
    [enums_1.AttributeType.BurnDamageIncrease]: true,
    [enums_1.AttributeType.ChillDamageIncrease]: true,
    [enums_1.AttributeType.CurseDamageIncrease]: true,
    [enums_1.AttributeType.AllDamageImmunity]: true,
    [enums_1.AttributeType.AllDamagePercentIncrease]: true,
    [enums_1.AttributeType.ChaosDamageImmunity]: true,
    [enums_1.AttributeType.ChaosDamagePercentIncrease]: true,
    [enums_1.AttributeType.DeathDamageImmunity]: true,
    [enums_1.AttributeType.DeathDamagePercentIncrease]: true,
    [enums_1.AttributeType.FireDamageImmunity]: true,
    [enums_1.AttributeType.FireDamagePercentIncrease]: true,
    [enums_1.AttributeType.FrostDamageImmunity]: true,
    [enums_1.AttributeType.FrostDamagePercentIncrease]: true,
    [enums_1.AttributeType.HolyDamageImmunity]: true,
    [enums_1.AttributeType.HolyDamagePercentIncrease]: true,
    [enums_1.AttributeType.NatureDamageImmunity]: true,
    [enums_1.AttributeType.NatureDamagePercentIncrease]: true,
    [enums_1.AttributeType.PhysicalDamageImmunity]: true,
    [enums_1.AttributeType.PhysicalDamagePercentIncrease]: true,
    [enums_1.AttributeType.SonicDamageImmunity]: true,
    [enums_1.AttributeType.SonicDamagePercentIncrease]: true,
    [enums_1.AttributeType.AbsoluteAllDamageImmunity]: true,
    [enums_1.AttributeType.AbsoluteChaosDamageImmunity]: true,
    [enums_1.AttributeType.AbsoluteDeathDamageImmunity]: true,
    [enums_1.AttributeType.AbsoluteFireDamageImmunity]: true,
    [enums_1.AttributeType.AbsoluteFrostDamageImmunity]: true,
    [enums_1.AttributeType.AbsoluteHolyDamageImmunity]: true,
    [enums_1.AttributeType.AbsoluteNatureDamageImmunity]: true,
    [enums_1.AttributeType.AbsolutePhysicalDamageImmunity]: true,
    [enums_1.AttributeType.AbsoluteSonicDamageImmunity]: true,
};
function mkMeta(attribute, extra = {}) {
    const display = attribute.replace(/([A-Z])/g, " $1").slice(1);
    return {
        attr: enums_1.AttributeType[attribute],
        attrKey: attribute,
        label: display,
        abbreviation: display,
        isPrimary: false,
        isPercent: false,
        isItemPercent: extra.isPercent || false,
        isLogged: true,
        isHarmful: false,
        ...extra
    };
}
// Shallow copy and override necessary
// No longer used: Agility, Accuracy, Armor, Dodge
// Use eternity lib ability tooltips
function getAttributeMeta(attr, defaultValue = enums_1.AttributeType.None) {
    const attrEnum = typeof attr === "number" ? attr : enums_1.AttributeType[attr];
    return (0, Record_1.getValueOrDefault)(exports.AttributesMeta, attrEnum, exports.AttributesMeta[defaultValue]);
}
exports.getAttributeMeta = getAttributeMeta;
exports.AttributesMeta = {
    [enums_1.AttributeType.None]: mkMeta("None", { isLogged: false }),
    // DEPRECATED
    [enums_1.AttributeType.SpellPoints]: mkMeta("SpellPoints", { isLogged: false }),
    [enums_1.AttributeType.Agility]: mkMeta("Agility", { isPrimary: true, abbreviation: "AGI", isLogged: false }),
    [enums_1.AttributeType.Accuracy]: mkMeta("Accuracy", { isPrimary: true, abbreviation: "ACC", isLogged: false }),
    [enums_1.AttributeType.Armor]: mkMeta("Armor", { abbreviation: "ARM", isLogged: false }),
    [enums_1.AttributeType.Dodge]: mkMeta("Dodge", { abbreviation: "DGE", isLogged: false }),
    // PRIMARY
    [enums_1.AttributeType.Health]: mkMeta("Health", { isPrimary: true, abbreviation: "HP" }),
    [enums_1.AttributeType.Power]: mkMeta("Power", { isPrimary: true, abbreviation: "POW", isItemPercent: true }),
    [enums_1.AttributeType.Focus]: mkMeta("Focus", { isPrimary: true, abbreviation: "FOC", isItemPercent: true }),
    [enums_1.AttributeType.Vitality]: mkMeta("Vitality", { isPrimary: true, abbreviation: "VIT", isItemPercent: true }),
    [enums_1.AttributeType.Toughness]: mkMeta("Toughness", { isPrimary: true, abbreviation: "TOU", isItemPercent: true }),
    [enums_1.AttributeType.Will]: mkMeta("Will", { isPrimary: true, abbreviation: "WIL", isItemPercent: true }),
    [enums_1.AttributeType.Luck]: mkMeta("Luck", { isPrimary: true, abbreviation: "LUC", isItemPercent: true }),
    [enums_1.AttributeType.CriticalStrikeChance]: mkMeta("CriticalStrikeChance", { isPercent: true, label: "Crit. Chance", abbreviation: "CRIT %" }),
    [enums_1.AttributeType.CriticalDamageMultiplier]: mkMeta("CriticalDamageMultiplier", { isPercent: true, label: "Crit. Damage", abbreviation: "CRIT DMG %" }),
    [enums_1.AttributeType.CriticalDamageReductionPercent]: mkMeta("CriticalDamageReductionPercent", { isPercent: true, label: "Crit. Damage Reduction", abbreviation: "CRIT DMG REDUCE %" }),
    [enums_1.AttributeType.ExtraActions]: mkMeta("ExtraActions", { isPercent: false, label: "Actions", abbreviation: "ACT" }),
    [enums_1.AttributeType.Haste]: mkMeta("Haste", { isPercent: true, abbreviation: "HAS" }),
    [enums_1.AttributeType.HasteStacks]: mkMeta("HasteStacks", { isLogged: false }),
    [enums_1.AttributeType.VulnerabilityStacks]: mkMeta("VulnerabilityStacks", { isLogged: false, isHarmful: true }),
    [enums_1.AttributeType.SlowStacks]: mkMeta("SlowStacks", { isLogged: false, isHarmful: true }),
    [enums_1.AttributeType.RevengeStacks]: mkMeta("RevengeStacks", { isLogged: false, isHarmful: true }),
    // DoT Damage Increase
    [enums_1.AttributeType.BurnDamageIncrease]: mkMeta("BurnDamageIncrease", { isPercent: true, abbreviation: "BURN DMG", altLabel: "Burn" }),
    [enums_1.AttributeType.BleedDamageIncrease]: mkMeta("BleedDamageIncrease", { isPercent: true, abbreviation: "BLEED DMG", altLabel: "Bleed" }),
    [enums_1.AttributeType.ChillDamageIncrease]: mkMeta("ChillDamageIncrease", { isPercent: true, abbreviation: "CHILL DMG", altLabel: "Chill" }),
    [enums_1.AttributeType.PoisonDamageIncrease]: mkMeta("PoisonDamageIncrease", { isPercent: true, abbreviation: "POISON DMG", altLabel: "Poison" }),
    [enums_1.AttributeType.CurseDamageIncrease]: mkMeta("CurseDamageIncrease", { isPercent: true, abbreviation: "CURSE DMG", altLabel: "Curse" }),
    // DoT Damage Immunities
    [enums_1.AttributeType.BurnDamageImmunity]: mkMeta("BurnDamageImmunity", { isPercent: true, abbreviation: "BURN IMM", altLabel: "Burn Immunity" }),
    [enums_1.AttributeType.BleedDamageImmunity]: mkMeta("BleedDamageImmunity", { isPercent: true, abbreviation: "BLEED IMM", altLabel: "Bleed Immunity" }),
    [enums_1.AttributeType.ChillDamageImmunity]: mkMeta("ChillDamageImmunity", { isPercent: true, abbreviation: "CHILL IMM", altLabel: "Chill Immunity" }),
    [enums_1.AttributeType.PoisonDamageImmunity]: mkMeta("PoisonDamageImmunity", { isPercent: true, abbreviation: "POISON IMM", altLabel: "Poison Immunity" }),
    [enums_1.AttributeType.CurseDamageImmunity]: mkMeta("CurseDamageImmunity", { isPercent: true, abbreviation: "CURSE IMM", altLabel: "Curse Immunity" }),
    [enums_1.AttributeType.AllDamagePercentIncrease]: mkMeta("AllDamagePercentIncrease", { isPercent: true, abbreviation: "ALL DMG%", altLabel: "All" }),
    [enums_1.AttributeType.ChaosDamagePercentIncrease]: mkMeta("ChaosDamagePercentIncrease", { isPercent: true, abbreviation: "CHAOS DMG%", altLabel: "Chaos" }),
    [enums_1.AttributeType.DeathDamagePercentIncrease]: mkMeta("DeathDamagePercentIncrease", { isPercent: true, abbreviation: "DEATH DMG%", altLabel: "Death" }),
    [enums_1.AttributeType.FireDamagePercentIncrease]: mkMeta("FireDamagePercentIncrease", { isPercent: true, abbreviation: "FIRE DMG%", altLabel: "Fire" }),
    [enums_1.AttributeType.FrostDamagePercentIncrease]: mkMeta("FrostDamagePercentIncrease", { isPercent: true, abbreviation: "FROST DMG%", altLabel: "Frost" }),
    [enums_1.AttributeType.HolyDamagePercentIncrease]: mkMeta("HolyDamagePercentIncrease", { isPercent: true, abbreviation: "HOLY DMG%", altLabel: "Holy" }),
    [enums_1.AttributeType.NatureDamagePercentIncrease]: mkMeta("NatureDamagePercentIncrease", { isPercent: true, abbreviation: "NATURE DMG%", altLabel: "Nature" }),
    [enums_1.AttributeType.PhysicalDamagePercentIncrease]: mkMeta("PhysicalDamagePercentIncrease", { isPercent: true, abbreviation: "PHYSICAL DMG%", altLabel: "Physical" }),
    [enums_1.AttributeType.SonicDamagePercentIncrease]: mkMeta("SonicDamagePercentIncrease", { isPercent: true, abbreviation: "SONIC DMG%", altLabel: "Sonic" }),
    [enums_1.AttributeType.PercentHealingIncrease]: mkMeta("PercentHealingIncrease", { isPercent: true, label: "Heal Bonus", abbreviation: "HEAL+" }),
    [enums_1.AttributeType.PercentHealingDecrease]: mkMeta("PercentHealingDecrease", { isPercent: true, isHarmful: true, label: "Heal Penalty", abbreviation: "HEAL-" }),
    [enums_1.AttributeType.PercentHealingReceivedDecrease]: mkMeta("PercentHealingReceivedDecrease", { isPercent: true, isHarmful: true, label: "Heal Recieved Decrease", abbreviation: "HEAL CUT-" }),
    [enums_1.AttributeType.AllDamageResistance]: mkMeta("AllDamageResistance", { abbreviation: "ALL DMG RESIST" }),
    [enums_1.AttributeType.ChaosDamageResistance]: mkMeta("ChaosDamageResistance", { abbreviation: "CHAOS DMG RESIST" }),
    [enums_1.AttributeType.DeathDamageResistance]: mkMeta("DeathDamageResistance", { abbreviation: "DEATH DMG RESIST" }),
    [enums_1.AttributeType.FireDamageResistance]: mkMeta("FireDamageResistance", { abbreviation: "FIRE DMG RESIST" }),
    [enums_1.AttributeType.FrostDamageResistance]: mkMeta("FrostDamageResistance", { abbreviation: "FROST DMG RESIST" }),
    [enums_1.AttributeType.HolyDamageResistance]: mkMeta("HolyDamageResistance", { abbreviation: "HOLY DMG RESIST" }),
    [enums_1.AttributeType.NatureDamageResistance]: mkMeta("NatureDamageResistance", { abbreviation: "NATURE DMG RESIST" }),
    [enums_1.AttributeType.PhysicalDamageResistance]: mkMeta("PhysicalDamageResistance", { abbreviation: "PHYSICAL DMG RESIST" }),
    [enums_1.AttributeType.SonicDamageResistance]: mkMeta("SonicDamageResistance", { abbreviation: "SONIC DMG RESIST" }),
    [enums_1.AttributeType.AllDamageImmunity]: mkMeta("AllDamageImmunity", { isPercent: true, abbreviation: "ALL DMG IMMUNITY" }),
    [enums_1.AttributeType.ChaosDamageImmunity]: mkMeta("ChaosDamageImmunity", { isPercent: true, abbreviation: "CHAOS DMG IMMUNITY" }),
    [enums_1.AttributeType.DeathDamageImmunity]: mkMeta("DeathDamageImmunity", { isPercent: true, abbreviation: "DEATH DMG IMMUNITY" }),
    [enums_1.AttributeType.FireDamageImmunity]: mkMeta("FireDamageImmunity", { isPercent: true, abbreviation: "FIRE DMG IMMUNITY" }),
    [enums_1.AttributeType.FrostDamageImmunity]: mkMeta("FrostDamageImmunity", { isPercent: true, abbreviation: "FROST DMG IMMUNITY" }),
    [enums_1.AttributeType.HolyDamageImmunity]: mkMeta("HolyDamageImmunity", { isPercent: true, abbreviation: "HOLY DMG IMMUNITY" }),
    [enums_1.AttributeType.NatureDamageImmunity]: mkMeta("NatureDamageImmunity", { isPercent: true, abbreviation: "NATURE DMG IMMUNITY" }),
    [enums_1.AttributeType.PhysicalDamageImmunity]: mkMeta("PhysicalDamageImmunity", { isPercent: true, abbreviation: "PHYS DMG IMMUNITY" }),
    [enums_1.AttributeType.SonicDamageImmunity]: mkMeta("SonicDamageImmunity", { isPercent: true, abbreviation: "SONIC DMG IMMUNITY" }),
    [enums_1.AttributeType.AbsoluteAllDamageImmunity]: mkMeta("AbsoluteAllDamageImmunity", { isPercent: true, abbreviation: "ABS ALL DMG IMMUNITY" }),
    [enums_1.AttributeType.AbsoluteChaosDamageImmunity]: mkMeta("AbsoluteChaosDamageImmunity", { isPercent: true, abbreviation: "ABS CHAOS DMG IMMUNITY" }),
    [enums_1.AttributeType.AbsoluteDeathDamageImmunity]: mkMeta("AbsoluteDeathDamageImmunity", { isPercent: true, abbreviation: "ABS DEATH DMG IMMUNITY" }),
    [enums_1.AttributeType.AbsoluteFireDamageImmunity]: mkMeta("AbsoluteFireDamageImmunity", { isPercent: true, abbreviation: "ABS FIRE DMG IMMUNITY" }),
    [enums_1.AttributeType.AbsoluteFrostDamageImmunity]: mkMeta("AbsoluteFrostDamageImmunity", { isPercent: true, abbreviation: "ABS FROST DMG IMMUNITY" }),
    [enums_1.AttributeType.AbsoluteHolyDamageImmunity]: mkMeta("AbsoluteHolyDamageImmunity", { isPercent: true, abbreviation: "ABS HOLY DMG IMMUNITY" }),
    [enums_1.AttributeType.AbsoluteNatureDamageImmunity]: mkMeta("AbsoluteNatureDamageImmunity", { isPercent: true, abbreviation: "ABS NATURE DMG IMMUNITY" }),
    [enums_1.AttributeType.AbsolutePhysicalDamageImmunity]: mkMeta("AbsolutePhysicalDamageImmunity", { isPercent: true, abbreviation: "ABS PHYSICAL DMG IMMUNITY" }),
    [enums_1.AttributeType.AbsoluteSonicDamageImmunity]: mkMeta("AbsoluteSonicDamageImmunity", { isPercent: true, abbreviation: "ABS SONIC DMG IMMUNITY" }),
    // xp boost charm
    [enums_1.AttributeType.XP_Boost]: mkMeta("XP_Boost", {
        abbreviation: "+25% xp",
        label: "Increases XP Gained by 25%",
        isBoolean: true
    }),
    // Kaboom Charms
    [enums_1.AttributeType.Charm_Warrior_0]: mkMeta("Charm_Warrior_0", {
        abbreviation: "Warrior: Rapid Striking",
        label: "Rapid Strikes always hits 7 times.",
        isBoolean: true
    }),
    [enums_1.AttributeType.Charm_Vampire_0]: mkMeta("Charm_Vampire_0", {
        abbreviation: "Vampire: Unholy Pact",
        label: "Blood Pact heals all allies from damage dealt.",
        isBoolean: true
    }),
    [enums_1.AttributeType.Charm_Valkyrie_0]: mkMeta("Charm_Valkyrie_0", {
        abbreviation: "Valkyrie: Aggravated Arcing",
        label: "Arc taunts the target for 4 turns.",
        isBoolean: true
    }),
    [enums_1.AttributeType.Charm_HighPriestess_0]: mkMeta("Charm_HighPriestess_0", {
        abbreviation: "High Priestess: Divine Penance",
        label: "Healing spells cast Blast at a random enemy.",
        isBoolean: true
    }),
    [enums_1.AttributeType.Charm_Augur_0]: mkMeta("Charm_Augur_0", {
        abbreviation: "Augur: North's Boon",
        label: "North's Infinitum incrases the max health of all allies by 25%.",
        isBoolean: true
    }),
    [enums_1.AttributeType.Charm_Assassin_0]: mkMeta("Charm_Assassin_0", {
        abbreviation: "Assassin: Dicing",
        label: "Mince applies 5% vulnerability on hit.",
        isBoolean: true
    }),
    [enums_1.AttributeType.Charm_Avenger_0]: mkMeta("Charm_Avenger_0", {
        abbreviation: "Avenger: Prolonged Fury",
        label: "The duration of Righteous Fury is increased by 2 turns.",
        isBoolean: true
    }),
    [enums_1.AttributeType.Charm_Tempest_0]: mkMeta("Charm_Tempest_0", {
        abbreviation: "Tempest: Reflective Mirrors",
        label: "Mirror summons an additional mirror.",
        isBoolean: true
    }),
    [enums_1.AttributeType.Charm_Executioner_0]: mkMeta("Charm_Executioner_0", {
        abbreviation: "Executioner: Extended Pardon",
        label: "Pardon now affects all allies.",
        isBoolean: true
    }),
    [enums_1.AttributeType.Charm_Ranger_0]: mkMeta("Charm_Ranger_0", {
        abbreviation: "Ranger: Call of Fire",
        label: "Call of the Wild now summons a Dragon Whelp.",
        isBoolean: true
    }),
    [enums_1.AttributeType.Charm_Sunbreaker_0]: mkMeta("Charm_Sunbreaker_0", {
        abbreviation: "Sunbreaker: Improved Radiance",
        label: "Radiance now removes a random debuff from each ally when the Sunbreaker deals damage.",
        isBoolean: true
    }),
    [enums_1.AttributeType.Charm_ThunderCaller_0]: mkMeta("Charm_ThunderCaller_0", {
        abbreviation: "Thunder Caller: SUPERBOLT",
        label: "Superbolt now casts twice.",
        isBoolean: true
    }),
    [enums_1.AttributeType.Charm_Monk_0]: mkMeta("Charm_Monk_0", {
        abbreviation: "Monk: Enhanced Defenses",
        label: "Impenetrable Defense now blocks the next attack.",
        isBoolean: true
    }),
    [enums_1.AttributeType.Charm_Gladiator_0]: mkMeta("Charm_Gladiator_0", {
        abbreviation: "Gladiator: Serrated Slashing",
        label: "Triple Slash now causes bleeding.",
        isBoolean: true
    }),
    [enums_1.AttributeType.Charm_Gambler_0]: mkMeta("Charm_Gambler_0", {
        abbreviation: "Gambler: Sticky Fingers",
        label: "Theft now steals attributes from all enemies.",
        isBoolean: true
    }),
    [enums_1.AttributeType.Charm_Necromancer_0]: mkMeta("Charm_Necromancer_0", {
        abbreviation: "Necromancer: Ruinated Summoning",
        label: "Ruination now has a chance to cast a slotted summon ability.",
        isBoolean: true
    }),
    [enums_1.AttributeType.Charm_Druid_0]: mkMeta("Charm_Druid_0", {
        abbreviation: "Druid: Refracted Moonlight",
        label: "Moonfire now attacks all targets.",
        isBoolean: true
    }),
    // Hamm Charms
    [enums_1.AttributeType.Charm_Warrior_1]: mkMeta("Charm_Warrior_1", {
        abbreviation: "Warrior: Whirling Fury",
        label: "Whirlwind deals damage twice.",
        isBoolean: true
    }),
    [enums_1.AttributeType.Charm_Vampire_1]: mkMeta("Charm_Vampire_1", {
        abbreviation: "Vampire: Kissing Booth",
        label: "Emilia's Kiss of Sorrow attacks all enemies.",
        isBoolean: true
    }),
    [enums_1.AttributeType.Charm_Valkyrie_1]: mkMeta("Charm_Valkyrie_1", {
        abbreviation: "Valkyrie: Midnight Carnival",
        label: "Dark Carnival summons an additional Archangel.",
        isBoolean: true
    }),
    [enums_1.AttributeType.Charm_HighPriestess_1]: mkMeta("Charm_HighPriestess_1", {
        abbreviation: "High Priestess: Unburdened Embrace",
        label: "Sori's Hug increase the targets' Power or Focus, whichever is higher.",
        isBoolean: true
    }),
    [enums_1.AttributeType.Charm_Augur_1]: mkMeta("Charm_Augur_1", {
        abbreviation: "Augur: Jeepers Creepers",
        label: "Hoodoo attacks all enemies.",
        isBoolean: true
    }),
    [enums_1.AttributeType.Charm_Assassin_1]: mkMeta("Charm_Assassin_1", {
        abbreviation: "Assassin: Serrated Blades",
        label: "Lacerate deals extra damage to bosses.",
        isBoolean: true
    }),
    [enums_1.AttributeType.Charm_Avenger_1]: mkMeta("Charm_Avenger_1", {
        abbreviation: "Avenger: Lay on Hands",
        label: "Ryver's Touch heals all allies.",
        isBoolean: true
    }),
    [enums_1.AttributeType.Charm_Tempest_1]: mkMeta("Charm_Tempest_1", {
        abbreviation: "Tempest: Electroshock Therapy",
        label: "Stormstrike applies convulsions to the enemy.",
        isBoolean: true
    }),
    [enums_1.AttributeType.Charm_Executioner_1]: mkMeta("Charm_Executioner_1", {
        abbreviation: "Executioner: Allegations",
        label: "Indictment removes buffs from the target.",
        isBoolean: true
    }),
    [enums_1.AttributeType.Charm_Ranger_1]: mkMeta("Charm_Ranger_1", {
        abbreviation: "Ranger: Massacring",
        label: "Kill Shot deals less damage but targets all enemies.",
        isBoolean: true
    }),
    [enums_1.AttributeType.Charm_Sunbreaker_1]: mkMeta("Charm_Sunbreaker_1", {
        abbreviation: "Sunbreaker: Meteoric Metal",
        label: "Drop the Hammer summons a Meteor Golem instead of a Hammer.",
        isBoolean: true
    }),
    [enums_1.AttributeType.Charm_ThunderCaller_1]: mkMeta("Charm_ThunderCaller_1", {
        abbreviation: "Thunder Caller: Static Discharge",
        label: "Arc Lightning has a chance to arc between enemies.",
        isBoolean: true
    }),
    [enums_1.AttributeType.Charm_Monk_1]: mkMeta("Charm_Monk_1", {
        abbreviation: "Monk: Overwhelmed Mauling",
        label: "Maul has a chance to overwhelm and instantly kill non-boss enemies.",
        isBoolean: true
    }),
    [enums_1.AttributeType.Charm_Gladiator_1]: mkMeta("Charm_Gladiator_1", {
        abbreviation: "Gladiator: Cornered Rage",
        label: "Disembowel deals extra damage when the target's health percent is greater than the gladiator's health percent.",
        isBoolean: true
    }),
    [enums_1.AttributeType.Charm_Gambler_1]: mkMeta("Charm_Gambler_1", {
        abbreviation: "Gambler: Restorative Deck",
        label: "Card Toss has a chance to remove debuffs from each ally.",
        isBoolean: true
    }),
    [enums_1.AttributeType.Charm_Necromancer_1]: mkMeta("Charm_Necromancer_1", {
        abbreviation: "Necromancer: Improved Summoning",
        label: "Summoning abilities summon two creatures instead of one.",
        isBoolean: true
    }),
    [enums_1.AttributeType.Charm_Druid_1]: mkMeta("Charm_Druid_1", {
        abbreviation: "Druid: Frozen Fire",
        label: "Wildfire deals cold damage in addition to fire damage.",
        isBoolean: true
    }),
};
